import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "app-container" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = {
  key: 0,
  class: "app-footer"
}
const _hoisted_4 = { class: "footer-content" }
const _hoisted_5 = { class: "footer-brand" }
const _hoisted_6 = {
  class: "footer-nav",
  "aria-label": "Footer"
}
const _hoisted_7 = { class: "footer-copy" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AppToast = _resolveComponent("AppToast")!
  const _component_AppConfirmDialog = _resolveComponent("AppConfirmDialog")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppHeader),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(_component_AppToast),
    _createVNode(_component_AppConfirmDialog),
    (!_ctx.isAdminRoute)
      ? (_openBlock(), _createElementBlock("footer", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[5] || (_cache[5] = _createElementVNode("p", { class: "footer-name" }, "Attractive Salon & Academy", -1)),
              _cache[6] || (_cache[6] = _createElementVNode("p", { class: "footer-tagline" }, "Beauty. Learning. Confidence.", -1)),
              _createElementVNode("nav", _hoisted_6, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode("Home")
                  ])),
                  _: 1,
                  __: [0]
                }),
                _createVNode(_component_router_link, { to: "/about" }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode("About")
                  ])),
                  _: 1,
                  __: [1]
                }),
                _createVNode(_component_router_link, { to: "/services" }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("Services")
                  ])),
                  _: 1,
                  __: [2]
                }),
                _createVNode(_component_router_link, { to: "/book-appointment" }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode("Book")
                  ])),
                  _: 1,
                  __: [3]
                }),
                _createVNode(_component_router_link, { to: "/academy-enquiry" }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("Academy")
                  ])),
                  _: 1,
                  __: [4]
                })
              ])
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "footer-contact" }, [
              _createElementVNode("p", null, [
                _createTextVNode(" Near Ayush Hospital, Rail Toly"),
                _createElementVNode("br"),
                _createTextVNode(" Gondia, Maharashtra – 441614, India ")
              ]),
              _createElementVNode("p", null, [
                _createElementVNode("a", { href: "tel:+918446607478" }, "+91-844-660-7478"),
                _createTextVNode("  ·  "),
                _createElementVNode("a", { href: "mailto:attractiveunisexsalon@gmail.com" }, "attractiveunisexsalon@gmail.com")
              ])
            ], -1))
          ]),
          _createElementVNode("p", _hoisted_7, "© " + _toDisplayString(new Date().getFullYear()) + " Attractive Unisex Salon. All rights reserved.", 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}